import React, { Component } from 'react';
import { wrapMultiLineText } from '../../helpers';
import { Dropdown, Grid } from 'semantic-ui-react';
import VegaChart from '../../common/vega/VegaChart';
import { treemapUstatPostgraduatesPHD } from '../../common/vega/VegaSpecifications';
import * as _ from 'lodash';
import * as d3 from 'd3';
import * as dl from 'datalib';
import { getUSTATDataPHD } from './ustat-dataretriever-phd';
import Preloader from '../../components/Preloader';
import { CSVLink } from "react-csv";
import {strings} from '../../common/translations'

class DataVizUstatPostgraduatesPHD extends Component {
    
    constructor(props) {
        super(props);
        // dropdown options
        this.ustatPosgraduateOrganizationsOptions = undefined;
        this.ustatPosgraduateYearsOptions = undefined;
        this.ustatPosgraduateGenderOptions = undefined;
        this.ustatPosgraduateStudentTypeOptions = undefined;

        this.state = {
            ustatPostgraduateOrganizations: [],
            ustatPostgraduateYears: [],
            ustatPostgraduateGender: [],
            yearFilter: undefined,
            organizationsFilter: undefined,
            genderFilter: undefined,
            studentTypeFilter: undefined
        };        
    }



    /**
     * Retrieve all the data to ppopulate comboboxes and the visualization
     */
    async componentDidMount() { 
        const data = await getUSTATDataPHD();

        // populate dropdown options
        this.ustatPosgraduateOrganizationsOptions = _.map(
            _.map(_.uniqBy(data, 'organizationName'), 'organizationName'),
            (organization, index) => ({
                key: index,
                text: organization,
                value: organization
            })
        );

        this.ustatPosgraduateYearsOptions = _.map(
            _.map(_.uniqBy(data, 'year'), 'year').sort(),
            (year, index) => ({
                key: index,
                text: year,
                value: year
            })
        );

        this.ustatPosgraduateGenderOptions = [
            { key: 0, text: strings.ALTA_FORMAZIONE.CHARTS.TREEMAP.SELECTOR_GENDER_OPTIONS.OPTION_1, value: "female" },
            { key: 1, text: strings.ALTA_FORMAZIONE.CHARTS.TREEMAP.SELECTOR_GENDER_OPTIONS.OPTION_2, value: "male" }
        ];

        this.ustatPosgraduateStudentTypeOptions = [
            { key: 0, text: strings.ALTA_FORMAZIONE.CHARTS.TREEMAP.SELECTOR_TYPOLOGY_OPTIONS.OPTION_1, value: "iscritti" },
            { key: 1, text: strings.ALTA_FORMAZIONE.CHARTS.TREEMAP.SELECTOR_TYPOLOGY_OPTIONS.OPTION_2, value: "diplomati" }
        ];

        this.setState({ data: data });
    }


    /**
     * 
     */
    updateLabels(selector) { 
        const leavesTexts = d3.select('.dataviz-treemap-phd')
                .selectAll('.mark-text.text-' + selector + ' > text'),
            leavesRectsNodes = d3.select('.dataviz-treemap-phd')
                .selectAll('.mark-rect.rect-' + selector + ' > path')
                .nodes();

        // texts and rects of the cells have the same order, so first
        // text child relates to first rect child, and so on
        leavesTexts.each( function(d, i)  {
            d3.select(this).call(
                wrapMultiLineText, 
                parseInt(leavesRectsNodes[i].__data__.x2 - leavesRectsNodes[i].__data__.x)
            );
        });
    }



    render() {
        const { 
            data,
            yearFilter,
            genderFilter,
            organizationsFilter,
            studentTypeFilter
        } = this.state;
        
        if(!_.isNil(data)) {
            let treeMapData = _.clone(data);

            // filter by selected org, if any
            if(organizationsFilter)
                treeMapData = _.filter(treeMapData, o => o.organizationName === organizationsFilter);

            // filter by student type, if any
            if(studentTypeFilter)
                treeMapData = _.filter(treeMapData, o => o.studentType === studentTypeFilter);

            // filter by specific year, if any        
            if(yearFilter) 
                treeMapData = _.filter(treeMapData, o => o.year === yearFilter);

            // filter by specific gender, if any        
            if (genderFilter) {
                if(genderFilter === "female") {
                    treeMapData = _.filter(treeMapData, o => o.total = o.female + o.foreignFemale)
                } else {
                    treeMapData = _.filter(treeMapData, o => o.total = o.male + o.foreignMale)
                }
            } else {
                treeMapData = _.filter(treeMapData, o => o.total = o.male + o.foreignMale + o.female + o.foreignFemale)
            }
            
            treeMapData = dl.groupby(['organizationName', 'courseName'])
                .summarize([
                    { 'name': 'total', ops:['sum'], as: ['total']},
                ])
                .execute(treeMapData);            


            
            return (
                <Grid centered>
                    <Grid.Row centered className="mb-0 pb-0">                    
                        <Dropdown 
                            placeholder={strings.ALTA_FORMAZIONE.CHARTS.TREEMAP.SELECTOR_UNIVERSITY_PLACEHOLDER}
                            search
                            selection
                            clearable
                            options={this.ustatPosgraduateOrganizationsOptions}
                            onChange={(event, data) => {
                                _.find(
                                    treemapUstatPostgraduatesPHD.signals, 
                                    signal => signal.name === 'organization'
                                ).value = _.isEmpty(data.value)? null : data.value;
                                this.setState({ organizationsFilter: data.value});
                            }}
                            className='dropdown-organizations'
                        />
                        <Dropdown 
                            placeholder={strings.ALTA_FORMAZIONE.CHARTS.TREEMAP.SELECTOR_YEAR_PLACEHOLDER}
                            search
                            selection
                            clearable
                            options={this.ustatPosgraduateYearsOptions}
                            onChange={(event, data) => {
                                this.setState({ yearFilter: data.value});
                            }}
                            className='dropdown-years ml-2'
                        />
                        <Dropdown 
                            placeholder={strings.ALTA_FORMAZIONE.CHARTS.TREEMAP.SELECTOR_GENDER_PLACEHOLDER}
                            search
                            selection
                            clearable
                            options={this.ustatPosgraduateGenderOptions}
                            onChange={(event, data) => {
                                this.setState({ genderFilter: data.value});
                            }}
                            className='dropdown-gender ml-2'
                        />
                        <Dropdown 
                            placeholder={strings.ALTA_FORMAZIONE.CHARTS.TREEMAP.SELECTOR_TYPOLOGY_PLACEHOLDER}
                            search
                            selection
                            clearable
                            options={this.ustatPosgraduateStudentTypeOptions}
                            onChange={(event, data) => {
                                this.setState({ studentTypeFilter: data.value});
                            }}
                            className='dropdown-gender ml-2'
                        />
                    </Grid.Row>
                    <Grid.Row centered className="mt-0 pt-0">
                        {treeMapData.length === 0 ?
                            <div className="emptystate"><p>{strings.COMMON.NO_DATA}</p></div>
                        :
                            <VegaChart
                                chartClass={'dataviz-treemap-phd'}
                                height={600}
                                data={treeMapData}
                                runAfterCallback={() => {
                                    this.updateLabels(this.state.organizationsFilter? 'leaves':'nodes');
                                }}
                                spec={treemapUstatPostgraduatesPHD}/>
                        }
                    </Grid.Row>
                    <Grid.Row className="border-top">
                        <Grid.Column width={16} className="d-flex flex-wrap">
                            <CSVLink data={data} 
                                    className="ui red circular icon button mx-auto"
                                    filename={"doveIscrivonoStudentiDottoratoToscana.csv"}>
                                        <i aria-hidden="true" className="download icon"></i>
                            </CSVLink>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            );
        }
        else
            return <Preloader message={strings.COMMON.LOADING_DATA} />
    }
}
export default DataVizUstatPostgraduatesPHD;